<template>
  <div class="content">
      <limit :visible="limit"
            :limitCode="limitCode"></limit>
    <router-view v-if="limit" ></router-view>
  </div>
</template>

<script>
import Vue from 'vue';
// import { formatLocale } from '@/localeUtil';
import limit from '@/components/common/limit/Limit';

export default {
  name: 'App',
  components: {
    limit
  },
  data () {
    return {
      routerCounter: 0,
      limitCode: null,
      isCabinetBuy: true,
    };
  },
  created () {
    
    
    console.log(1)
    Vue.prototype.Config = Config.init(this);
    // const permission = this.$route.meta.permission
    // if (permission.length) {
    //   this.isCurrentRouteCabinetBuy();
    // }
    this.getFilterList();
    this.getAlarmFiltersList();
    this.getLimit();
    this.getWorksheetMap();
  },
  computed: {
    limit() {
      return this.$store.state.limit.limit;
      // return true
    },
  },
  mounted() {
    document.title = this.$t('text.title');
    document.getElementsByTagName('html')[0].lang = this.$t('text.lang');
    console.log(this.$route.path)
  },
  methods: {
    async getLimit () {
      this.$store.commit('GET_LIMIT', null);
      console.log('created', 'limit', this.limit)
      await this.$api.getLimit().then((response) => {
        // var response = JSON.parse(response)
        console.log('用户权限', response);
        // this.$store.commit('GET_LIMIT', true);
        if (this.$route.path === '/aidc/create') {
          this.$store.commit('GET_LIMIT', true);
        } else {
          this.getMenuPermission()
        }
      }).catch((ex) => {
        this.limitCode = ex.errno
        if (this.$route.path === '/aidc/create' && this.limitCode === 20204) {
          this.$store.commit('GET_LIMIT', true);
        } else {
          this.$store.commit('GET_LIMIT', false);
        }
      });
    },
    getMenuPermission() {
      this.$api.getMenuPermission().then((response) => {
        // var response = JSON.parse(response)
        console.log('用户权限', response);
        const permission = this.$route.meta.permission
        if (permission.length && !response.data.menuPermission[permission]) {
          this.limitCode = 99999
          this.$store.commit('GET_LIMIT', false);
        } else {
          this.$store.commit('GET_LIMIT', true);
        }

      }).catch((ex) => {
        console.log(53, ex)
        this.limitCode = 99999
        this.$store.commit('GET_LIMIT', false);
      });
    },
    getFilterList () {
      this.$api.getFiltersList({idcLine: this.GLOBAL.IDCLINE}).then((response) => {
        // var response = JSON.parse(response)
        console.log('过滤数据', response);
        if (response.data) {
          this.$store.commit('GET_FILTERLIST', response.data);
        }
      });
    },
    getAlarmFiltersList () {
      this.$api.getAlarmFiltersList().then((response) => {
        if (response.data) {
          this.$store.commit('GET_ALARMFILTERLIST', response.data);
        }
      });
    },
    getWorksheetMap () {
      this.$api.getWorksheetMap({idcLine: this.GLOBAL.IDCLINE}).then((response) => {
        // var response = JSON.parse(response)
        if (response.data) {
          this.$store.commit('GET_WORKSHEETLIST', response.data);
        }
      });
    },
    /**
     **@disc: 当前页面是不是机柜购买页面
     **@author: mengln
     */
    isCurrentRouteCabinetBuy() {
      if(this.$route.path === '/aidc/create' && this.limitCode === 20204){
        this.isCabinetBuy = true
      }else{
        this.isCabinetBuy = false;
      }
    }
  },
  watch: {
    $route: {
      handler (newRoute) {
        this.getLimit();

        if (window.toRoutePath) { // consoleMenu 自动计算的高亮值可能出错，修正之
          const { path } = newRoute;
          setTimeout(() => window.toRoutePath(path, true), 500);
        }
      },
      // 深度观察监听
      deep: true
    },
  }
};
</script>

<style lang="scss">
@import './App';
</style>



// WEBPACK FOOTER //
// src/App.vue